import { KeywordPageLinkApiRequestParams } from 'models/KeywordPageLinkApiRequestParams';
import { KeywordPageLinkApiResponse } from 'models/KeywordPageLinkApiResponse';
import { STATUS_CODES } from './statusCodes';
import { determineKeywordApiUrl } from './urls';

export async function getKeywordPageLinksFromApi({
  environment,
  category,
  keyword
}: KeywordPageLinkApiRequestParams): Promise<KeywordPageLinkApiResponse> {
  const url = new URL(determineKeywordApiUrl(environment));
  url.searchParams.append('category', category);
  url.searchParams.append('keyword', keyword);

  const response: Response = await fetch(url.toString());

  if (!response.ok && response.status === STATUS_CODES.NOT_FOUND) {
    throw STATUS_CODES.GONE;
  }

  return (await response.json()) as KeywordPageLinkApiResponse;
}
